<template>
  <!-- <h4>Gestion des Droits</h4> -->
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des droits</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div slot="beforeTable">
            <b-button type="button"  @click="editRule('add')" class="pull-right mb-1" size="md" variant="primary">
              <i class="fa fa-plus"></i> Ajouter un droit
            </b-button>
          </div>
          <div slot="action" slot-scope="props">
            <b-button type="button" @click.prevent="destroy(props.row.id)" class="badge badge-danger mr-3 p-2"><i class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button type="button" @click="editRule('edit', props.row.id)" class="badge badge-primary p-2">
              <i class="fa fa-edit"></i> Modifier
            </b-button>
          </div>
          <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button type="button"  @click="editRule('add')" class="pull-right" size="md" variant="primary">
            <i class="fa fa-plus"></i> Ajouter un droit
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../../utils/auth'

export default {
  data () {
    return {
      columns: ['espace.nom', 'module.nom', 'libelle', 'libelle_technique', 'action'],
      data: [],
      options: {
        headings: {
          'espace.nom': 'Espace',
          'module.nom': 'Module',
          libelle: 'Libelle',
          libelle_technique: 'Libelle Technique',
          created_at: 'Date de création',
          action: 'Action'
        },
        sortable: ['espace.nom'],
        filterable: ['espace.nom','libelle'],
        perPage: 25,
        perPageValues:[10,25,50],
        texts:{
          filterPlaceholder:"Espace, Libelle"
        },
        //orderBy: {column: 'created_at', ascending: false}
      }
    }
  },
  mounted() {
    this.all()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
  	all() {
      let self = this;
      return this.$axios
        .get("/administration/droits")
        .then(response => {
          this.data = response.data.droits
        })
        .catch(function(error) {
          self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:'Un probléme est survenue, merci de contacter l\'administrateur',showConfirmButton: false, timer: 5000})
        });
    },
    destroy(id) {
      let self = this;
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: "Voulez-vous vraiment supprimer cette droit ?",
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (!result.value) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
            .post("/administration/droits/delete/"+id)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le droit a bien été supprimé',showConfirmButton: false, timer: 5000})
              this.all()
            })
            .catch(function(error){
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Un problème est survenu, merci de contacter un administrateur',showConfirmButton: false, timer: 5000})
            })
          }
        })

    },
    editRule(to,id) {
      if (to === 'edit') {
          this.$router.push({ path: '/administration/rules/edit/' + id })
      } else if(to === "add") {
          this.$router.push({ path: '/administration/rules/add' })
      }
    },
    formatDate(textDate) {
      return (textDate !== null) ? new Date(textDate).toLocaleDateString('fr-FR') : "-";
    }
  }
};
</script>
